app.service('productsListConfig', function(pageConfig) {
	function getData(){
		return pageConfig.getData('productsList');
	}
	
	return {
		getData: getData
	};
});